import React from "react";
import ReactLoading from "react-loading";
import { styled } from "@mui/system";

const StyledLoading = styled(ReactLoading)(({ transform }) => ({
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: transform || "translate(-40px, -50px)",
  zIndex: "999 !important",
}));

export default function ProgressBar({ transform }) {
  return (
    <StyledLoading
      type="spinningBubbles"
      color="#4096FC"
      height={75}
      width={75}
      transform={transform}
    />
  );
}
